import axios from 'axios';

const API_BASE = '/api/planner-sessions';

export async function getPlannerSessions() {
  try {
    const res = await axios.get(API_BASE);
    return res.data;
  } catch (err) {
    console.error('[PlannerService] Failed to fetch sessions:', err.response?.data || err);
    throw err;
  }
}

export async function createPlannerSession(data) {
  try {
    const res = await axios.post(API_BASE, data);
    return res.data;
  } catch (err) {
    console.error('[PlannerService] Failed to create session:', err.response?.data || err);
    throw err;
  }
}

export async function getPlannerSessionSummary(sessionId) {
  try {
    const res = await axios.get(`${API_BASE}/${sessionId}/summary`);
    return res.data;
  } catch (err) {
    console.error(`[PlannerService] Failed to fetch summary for session ${sessionId}:`, err.response?.data || err);
    throw err;
  }
}

export async function updatePlannerSession(sessionId, data) {
  try {
    const res = await axios.put(`${API_BASE}/${sessionId}`, data);
    return res.data;
  } catch (err) {
    console.error(`[PlannerService] Failed to update session ${sessionId}:`, err.response?.data || err);
    throw err;
  }
}



/** ---- Triager APIs ---- **/
export async function postPlannerTriage({ module }) {
  try {
    const res = await axios.post('/api/planner/triage', { module });
    return res.data;
  } catch (err) {
    console.error('[PlannerService] postPlannerTriage failed:', err.response?.data || err);
    throw err;
  }
}

export async function postPlannerTriageSnapshot({ module, result_json }) {
  try {
    const res = await axios.post('/api/planner/triage/snapshot', { module, result_json });
    return res.data;
  } catch (err) {
    console.error('[PlannerService] postPlannerTriageSnapshot failed:', err.response?.data || err);
    throw err;
  }
}
